import { createFileRoute, Navigate } from '@tanstack/react-router';

import { TagDefinitionsSection } from '@apps/web/components/settings/tag_definitions_section';
import {
    SettingsLoadingState,
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';
import { useMode } from '@apps/web/lib/mode_store';

export const Route = createFileRoute('/_app/settings/tags')({
    component: TagsPage,
});

function TagsPage() {
    const { organizationId, isLoading, gates } = useSettingsGates();
    const mode = useMode();
    if (isLoading) {
        return <SettingsLoadingState />;
    }
    if (!gates.internalAdmin) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="EHR Tags and Attributes"
            description="Tag descriptions help Phoebe match caregivers to clients. Edit any that look wrong, and move tags out of matching if they shouldn’t count."
            maxWidth="wide"
        >
            {/* Organization and mode switches do not navigate, so remount
                to drop drafts staged against the other catalog. */}
            <TagDefinitionsSection
                key={`${organizationId}:${mode ?? ''}`}
                organizationId={organizationId}
            />
        </SettingsPageShell>
    );
}
